function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import React, { useMemo } from "react";
import { inputContainerBase, inputContainerFocus, inputContainerVariant, inputDisabled, getInputContainerStyles, inputPlaceholder, inputPlaceholderDisabled } from "../../utils/css/input";
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(theme, param) {
    var readingDirection = param.readingDirection, start = param.start, end = param.end;
    var backgroundColor = theme.backgroundColor, borderColor = theme.borderColor, font = theme.font, size = theme.size, spacing = theme.spacing;
    var _obj;
    return {
        container: {
            base: _objectSpread({
                fontFamily: font.base.family,
                fontStyle: 'normal',
                fontWeight: font.base.weight.regular,
                letterSpacing: 'normal',
                lineHeight: font.lineHeight.base,
                textAlign: start.direction,
                textIndent: 0,
                textShadow: 'none',
                textTransform: 'none'
            }, inputContainerBase()),
            colorVariant: {
                brand: {
                    '> fieldset': {
                        borderColor: borderColor.brand.base
                    }
                },
                danger: {
                    '> fieldset': {
                        borderColor: borderColor.danger.base
                    }
                },
                warning: {
                    '> fieldset': {
                        borderColor: borderColor.warning.base
                    }
                },
                success: {
                    '> fieldset': {
                        borderColor: borderColor.success.base
                    }
                },
                grid: {},
                default: {},
                underline: {},
                outline: {}
            },
            variant: _objectSpread({}, inputContainerVariant()),
            focus: _objectSpread({}, inputContainerFocus(theme))
        },
        button: {
            base: _objectSpread({}, readingDirection, (_obj = {}, _defineProperty(_obj, end.padding, spacing[3]), _defineProperty(_obj, start.padding, spacing[5]), _defineProperty(_obj, "appearance", 'none'), _defineProperty(_obj, "border", 0), _defineProperty(_obj, "borderRadius", size.border.radius.threeX), _defineProperty(_obj, "boxSizing", 'border-box'), _defineProperty(_obj, "color", font.color.base), _defineProperty(_obj, "cursor", 'pointer'), _defineProperty(_obj, "display", 'flex'), _defineProperty(_obj, "fill", font.color.base), _defineProperty(_obj, "fontFamily", font.base.family), _defineProperty(_obj, "fontSize", font.base.size['4']), _defineProperty(_obj, "fontStyle", 'normal'), _defineProperty(_obj, "fontWeight", font.base.weight.regular), _defineProperty(_obj, "justifyContent", 'space-between'), _defineProperty(_obj, "letterSpacing", 'normal'), _defineProperty(_obj, "lineHeight", font.lineHeight.base), _defineProperty(_obj, "margin", 0), _defineProperty(_obj, "outline", 0), _defineProperty(_obj, "paddingBottom", spacing[3]), _defineProperty(_obj, "paddingTop", spacing[3]), _defineProperty(_obj, "textAlign", start.direction), _defineProperty(_obj, "textIndent", 0), _defineProperty(_obj, "textShadow", 'none'), _defineProperty(_obj, "textTransform", 'none'), _defineProperty(_obj, "width", '100%'), _defineProperty(_obj, '&:focus, &:focus-visible, &:active', {
                outline: 0
            }), _defineProperty(_obj, '&:disabled', _objectSpread({}, inputDisabled(theme), {
                fill: font.color.disabled,
                pointerEvents: 'none'
            })), _defineProperty(_obj, '&::-moz-focus-inner', {
                border: 0
            }), _obj)),
            variant: {
                default: {
                    backgroundColor: backgroundColor.base,
                    height: '40px'
                },
                underline: {
                    backgroundColor: 'transparent',
                    borderRadius: "".concat(size.border.radius.threeX, " ").concat(size.border.radius.threeX, " 0 0"),
                    paddingTop: '20px'
                },
                grid: {
                    backgroundColor: 'transparent',
                    borderRadius: "".concat(size.border.radius.threeX, " ").concat(size.border.radius.threeX, " 0 0"),
                    padding: '0 2px'
                },
                outline: {
                    backgroundColor: 'transparent',
                    marginTop: '10px'
                }
            }
        },
        placeholder: {
            base: _objectSpread({}, inputPlaceholder(theme), {
                textAlign: start.direction
            }, readingDirection, {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
            }),
            isDisabled: _objectSpread({}, inputPlaceholderDisabled(theme))
        },
        popper: {
            borderRadius: size.border.radius.threeX
        },
        icon: {
            pointerEvents: 'none',
            width: spacing[6],
            height: spacing[6],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        text: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        }
    };
};
export var useStyle = function(param) {
    var tmp = param.correctedVariant, variant = tmp === void 0 ? 'default' : tmp, hasError = param.hasError, isDisabled = param.isDisabled, isOpen = param.isOpen, isRtl = param.isRtl, colorVariant = param.variant;
    var ref3;
    var ref1 = (ref3 = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref3 !== void 0 ? ref3 : {}, container = ref1.container, button = ref1.button, icon = ref1.icon, placeholder = ref1.placeholder, popper = ref1.popper, text = ref1.text;
    return useMemo(function() {
        var ref, ref2;
        var inputContainerStyles = getInputContainerStyles({
            container: container,
            variant: variant,
            hasError: hasError
        });
        return {
            container: _objectSpread({}, container === null || container === void 0 ? void 0 : container.base, inputContainerStyles, colorVariant && (container === null || container === void 0 ? void 0 : (ref = container.colorVariant) === null || ref === void 0 ? void 0 : ref[colorVariant]), isOpen && {
                '> fieldset': inputContainerStyles['&:focus-within > fieldset']
            }),
            button: _objectSpread({}, button === null || button === void 0 ? void 0 : button.base, button === null || button === void 0 ? void 0 : (ref2 = button.variant) === null || ref2 === void 0 ? void 0 : ref2[variant]),
            icon: icon,
            placeholder: _objectSpread({}, placeholder === null || placeholder === void 0 ? void 0 : placeholder.base, isDisabled && (placeholder === null || placeholder === void 0 ? void 0 : placeholder.isDisabled)),
            popper: popper,
            text: text
        };
    }, [
        button,
        colorVariant,
        container,
        hasError,
        icon,
        isDisabled,
        isOpen,
        placeholder,
        popper,
        text,
        variant
    ]);
};
